import React from 'react';
import PropTypes from 'prop-types';

import styles from './mobileServiceButtons.module.css';

const getNote = (appt, script, allowScripts) => {
  if (appt === 4) {
    const root =
      'This practice only allows enrolled patients to book appointments online.';
    if (allowScripts) {
      if (script === 4)
        return `${root} To request a repeat prescription you must also be enrolled.`;
      if (script === 2)
        return `${root} To request a repeat prescription you must be an enrolled and funded patient.`;
    } else return root;
  }
  if (appt === 2) {
    const root =
      'This practice only allows enrolled and funded patients to book appointments online.';
    if (allowScripts) {
      if (script === 4)
        return `${root} To request a repeat prescription online you must be an enrolled patient.`;
      if (script === 2)
        return `${root} To request a repeat prescription online you must also be an enrolled and funded patient.`;
    } else return root;
  }
  if (appt === 8) {
    const root =
      'This practice only allows returning patients to book appointments online.';
    if (allowScripts) {
      if (script === 4)
        return `${root} To request a repeat prescription you must be an enrolled patient.`;
      if (script === 2)
        return `${root} To request a repeat prescription you must be an enrolled and funded patient.`;
      return 'This practice only allows returning patients to book appointments and request repeat prescriptions online.';
    } else return root;
  }
  if (allowScripts) {
    if (script === 4)
      return 'This practice only allows enrolled patients to request repeat prescriptions online.';
    if (script === 2)
      return 'This practice only allows enrolled and funded patients to request repeat prescriptions online.';
  }
  return '';
};

const MobileServiceButtons = ({
  onBook,
  onScript,
  appt,
  script,
  allowScripts,
  address,
}) => {
  const note = getNote(appt, script, allowScripts);
  return (
    <div className={styles.container}>
      {address && (
        <a
          className={styles.directions}
          href={`https://www.google.co.nz/maps/place/${address}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Get Directions
        </a>
      )}
      <button className={styles.blueButton} id="nw_book" onClick={onBook}>
        Book an Appointment
      </button>
      {allowScripts && (
        <button
          className={styles.whiteButton}
          id="nw_script"
          onClick={onScript}
        >
          Repeat a Prescription
        </button>
      )}
      {note && <div className={styles.note}>{note}</div>}
    </div>
  );
};

MobileServiceButtons.propTypes = {
  onBook: PropTypes.func.isRequired,
  onScript: PropTypes.func,
  appt: PropTypes.number,
  script: PropTypes.number,
  address: PropTypes.string,
  allowScripts: PropTypes.bool,
};

export default MobileServiceButtons;
